export enum CounterpartyStepCode {
  Name = 'name',
  Manager = 'manager',
  Address = 'address',
  Contact = 'contact',
  BankDetails = 'bankDetails',
  Subordination = 'subordination',
  Comment = 'comment',
  Execution = 'execution',
  Completion = 'completion',
}
